/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { marketReferenceMarketDtoSchema } from "./marketReferenceMarketDtoSchema.ts";
import { z } from "zod/v4";

export const marketIndustryDtoSchema = z.object({
  industryName: z.optional(z.string()),
  hint: z.optional(z.string()),
  get referenceMarkets() {
    return z.array(marketReferenceMarketDtoSchema).optional();
  },
});
